module.exports = __webpack_public_path__ + "img/corazonr.07570d8e.svg";